import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dash'
})
export class DashPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return value === null || value === undefined || value === '' ? '-' : value;
  }

}
